<template>
  <ContributionTable />
</template>

<script>
import ContributionTable from '@/components/ContributionTable.vue';

export default {
  components: {
    ContributionTable,
  },
};
</script>
